import React from 'react'
import { forwarderInitialValues, orderRatingByForwarderFieldOptions, orderRatingByForwarderSchema } from './utils'
import { FormOrderRatingsDialog } from './OrderRatingsDialog/FormOrderRatingsDialog'

export function ForwarderOrderRatingsDialog ({
  onSubmit,
  isOpen,
  closeable,
  disabled
}) {
  return (
    <FormOrderRatingsDialog onSubmit={onSubmit}
                        isOpen={isOpen}
                        closeable={closeable}
                        disabled={disabled}
                        ratingFormInitialValues={forwarderInitialValues}
                        formSchema={orderRatingByForwarderSchema}
                        ratingFields={orderRatingByForwarderFieldOptions}/>
  )
}
